import React from "react";
import { Box, Container, Divider, Typography } from "@mui/material";

const Clients1 = (porps) => {
  const { landingDetails, layoutDetails } = porps;
  return (
    
    <Box
      id="client"
    >
      <Box component="section" sx={{ py: 8}} id="service">
      <Container>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h3" sx={{  color: 'primary.main', marginBottom: 4 }}>
          <Divider>{layoutDetails?.title}</Divider>
        </Typography>
        <Typography variant="body1" sx={{ margin: 'auto', marginBottom: 8 }}>
          {layoutDetails?.description}
        </Typography>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
          {landingDetails?.map((client, index) => (
            <Box maxHeight={100} maxWidth={100} key={index} component="img" src={client.image} alt={client.name} sx={{  margin: 2 }}  onClick={() => window.open(client.description, '_blank')}/>
          ))}
        </Box>
      </Box>
      </Container>
    </Box>
     
    </Box>
  );
};

export default Clients1;
